module.exports = __webpack_public_path__ + "assets/images/notify-On.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/notify-On.png
// module id = 1521
// module chunks = 1